import { render, staticRenderFns } from "./HistoryItem.vue?vue&type=template&id=4238fa8c"
import script from "./HistoryItem.vue?vue&type=script&lang=js"
export * from "./HistoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4238fa8c')) {
      api.createRecord('4238fa8c', component.options)
    } else {
      api.reload('4238fa8c', component.options)
    }
    module.hot.accept("./HistoryItem.vue?vue&type=template&id=4238fa8c", function () {
      api.rerender('4238fa8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Academy/HistoryItem.vue"
export default component.exports